import React from 'react';
import EmployerLayout from './EmployerLayout';
import { EmployerPricing } from './organisms';

const EmployerPricingPage = () => {
  return (
    <EmployerLayout>
      <EmployerPricing />
    </EmployerLayout>
  );
};

export default EmployerPricingPage;
